export const colors = {
  green61: '#1CB561',
  orange02: '#BE5602',
  orange00: '#FF9900',
  orangeF0: '#F76F00',
  red: '#FF0000',
  skyBlueF6: '#0290F6',
  blue: '#1877F2',
  whiteFF: '#ffffff',
  purpleA5: '#5253A5',
  greyA6: '#A6A6A6',
  greyC4: '#C4C4C4',
  grey96: '#969696',
  greyF8: '#F8F8F8',
  greyD9: '#d9d9d929',
  back21: '#141721',
  back38: '#191d28',
  back36: '#212636',
  back1D: '#1D2131',
  text31: '#202431',
  lime02: '#B7F602',
  yellow08: '#f1be08'
};
